import React, { useEffect, useState, forwardRef } from 'react';
import PropTypes from 'prop-types';

import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

import { Card, Spinner, Col, Row, Form } from 'react-bootstrap';

import VentasPorVendedorChart from './VentasPorVendedorChart';
import TablaPromediosVendedores from './TablaPromediosVendedores';

import useToken from 'hooks/useToken';
import { useToast } from 'context/providers/ToastProvider';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ErrorBoundary from 'components/common/ErrorBoundary';



const VentasPorVendedor = ({
    items_Money

}) => {

    const { token, setToken } = useToken();
    const { showErrorToast } = useToast();
    const [cargando, setCargando] = useState(true);
    const [cargandoTabla, setCargandoTabla] = useState(false);

    const [chartData, setChartData] = useState({});
    const [promediosData, setPromediosData] = useState([]);
    const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());


    useEffect(
        () => {

            if (items_Money == 'MONEY') {
                obtenerIngresosNetosPorVendedor();
                setCargandoTabla(true);
                obtenerPromedioVentas();
            }


        }
        , []);

    useEffect(
        () => {
            setCargandoTabla(true);
            obtenerPromedioVentas();
        }
        , [selectedYear]);

    // Función para manejar el cambio de año
    const handleYearChange = (event) => {
        setSelectedYear(parseInt(event.target.value));
    };

    // Función para generar opciones de años desde 2022 hasta el año actual
    const generateYearOptions = () => {
        const currentYear = new Date().getFullYear();
        const years = [];
        for (let year = 2022; year <= currentYear; year++) {
            years.push(year);
        }
        return years;
    };


    /**
     * Obtiene las ventas por vendedor
     */
    const obtenerIngresosNetosPorVendedor = async () => {

        setCargando(true);

        const response = await fetch("/api/Administradores/ventasTotalesByVendedor",
            {
                method: 'POST',
                headers:
                {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                }
            }).catch((error) => {

                showErrorToast('Hubo un problema con la peticion Fetch:' + error);

                console.log('Hubo un problema con la peticion Fetch:' + error);
            });

        if (response.ok) {
            const responseType = await response.json();

            if (responseType.iResponseType == 1) {

                const data = JSON.parse(responseType.detalles);
                console.log("============= VENTAS POR VENDEDORES =================");
                console.log(data)

                var chartData_ = {
                    VentasPorVendedor: data.table2,
                    Vendedores: data.table3,
                };

                setChartData(chartData_);

                setCargando(false);

            } else {
                showErrorToast(responseType.vMessage);
            }

        }
        else {
            showErrorToast(response.status + ' ' + response.statusText);

            if (response.status == 401) {
                setToken(null);
                location.href = "";
            }
        }

        setCargando(false);
    }



    /**
     * Obtiene las ventas por vendedor
     */
    const obtenerPromedioVentas = async () => {

        setCargandoTabla(true);

        const body = {
            year: selectedYear,
        };
        const response = await fetch("/api/Administradores/obtenerPromedioVentas",
            {
                method: 'POST',
                headers:
                {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(body)

            }).catch((error) => {

                showErrorToast('Hubo un problema con la peticion Fetch:' + error);

                console.log('Hubo un problema con la peticion Fetch:' + error);
            });

        if (response.ok) {
            const responseType = await response.json();

            if (responseType.iResponseType == 1) {

                const data = JSON.parse(responseType.detalles);
                console.log("============= PROMEDIOS VENTAS POR VENDEDORES =================");
                console.log(data);
                const datos = data.table2


                // Procesar los datos para la nueva estructura de 3 años
                setPromediosData(datos);

            } else {
                showErrorToast(responseType.vMessage);
            }
            setCargandoTabla(false);
        }
        else {
            showErrorToast(response.status + ' ' + response.statusText);

            if (response.status == 401) {
                setToken(null);
                location.href = "";
            }

            setCargandoTabla(false);
        }

        
    }


    const GreetingsDateInput = forwardRef(({ value, onClick }, ref) => (
        <div className="position-relative">
            <Form.Control
                size="sm"
                ref={ref}
                onClick={onClick}
                value={value}
                className="ps-4"
                onChange={e => {
                    console.log({ e });
                }}
            />
            <FontAwesomeIcon
                icon="calendar-alt"
                className="text-primary position-absolute top-50 translate-middle-y ms-2"
            />
        </div>
    ));
    GreetingsDateInput.propTypes = {
        value: PropTypes.string,
        onClick: PropTypes.func
    };

    return (
        <>
            {
                cargando ?
                    <>
                        <Card >
                            <Card.Header>
                                <Row>
                                    <Col>
                                        <h5><Spinner className='text-inline mt-3 ms-2' animation='border' variant='primary' /> Cargando... Ventas por vendedor </h5>
                                    </Col>

                                </Row>


                            </Card.Header>

                        </Card>
                        <Skeleton height={400} style={{ "zIndex": "-1" }} />
                    </>
                    :
                    <>
                        <Row>

                            <Col className="col-12">

                                <Card>

                                    <Card.Body className="pe-xxl-0">

                                        <Row className="p-1">

                                            <Col className="col-12">

                                                <ErrorBoundary >
                                                    <VentasPorVendedorChart
                                                        chartData={chartData}
                                                    />
                                                </ErrorBoundary>

                                            </Col>



                                        </Row>

                                    </Card.Body>
                                </Card>


                                <Card className="mt-2">
                                    <Card.Header>
                                        <Row className="align-items-center">
                                            <Col>
                                                <h5 className="mb-0">Comparativa de promedio de venta</h5>
                                            </Col>
                                            <Col xs="auto">
                                                <Form.Select
                                                    size="sm"
                                                    value={selectedYear}
                                                    onChange={handleYearChange}
                                                    style={{ width: '120px' }}
                                                    disabled={cargandoTabla}
                                                >
                                                    {generateYearOptions().map(year => (
                                                        <option key={year} value={year}>
                                                            {year}
                                                        </option>
                                                    ))}
                                                </Form.Select>
                                            </Col>
                                        </Row>
                                    </Card.Header>
                                    <Card.Body>
                                        <Row>
                                            <ErrorBoundary >
                                                <Col className="col-12">
                                                    {cargandoTabla ? (
                                                        <div>
                                                       
                                                            <Skeleton height={300} />
                                                        </div>
                                                    ) : (

                                                        
                                                        <TablaPromediosVendedores
                                                            promediosData={promediosData}
                                                            selectedYear={selectedYear}
                                                        />
                                                        

                                                    )}
                                                </Col>
                                            </ErrorBoundary>
                                        </Row>
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>

                    </>
            }
        </>

    );
};

VentasPorVendedor.propTypes = {
    items_Money: PropTypes.string,
};

export default VentasPorVendedor;
